import React from 'react';
import { Tag, Tooltip } from 'antd';
import { CheckCircleFilled, PauseCircleFilled, MinusCircleFilled } from '@ant-design/icons';

const isS3DiscoverySource = (pipeline) =>
  String(pipeline?.status_source || pipeline?.discovery_source || '').includes('s3');

export default function AirflowDagStatus({ pipeline, compact = false, isDark = false }) {
  const fromS3 = isS3DiscoverySource(pipeline);
  const isPaused = Boolean(pipeline?.is_paused);
  const isActive =
    pipeline?.is_active !== false &&
    String(pipeline?.status || 'ACTIVE').toUpperCase() !== 'INACTIVE';

  const tagStyle = { margin: 0, fontSize: compact ? 11 : 12 };

  if (fromS3) {
    return (
      <Tooltip title="Pause state is not available from S3 discovery — refresh DAGs via MWAA API for scheduler status">
        <Tag icon={<CheckCircleFilled />} color="success" style={tagStyle}>
          Active
        </Tag>
      </Tooltip>
    );
  }

  if (isPaused) {
    return (
      <Tooltip title="DAG is paused in MWAA (scheduler will not trigger new runs)">
        <Tag icon={<PauseCircleFilled />} color="default" style={tagStyle}>
          Paused
        </Tag>
      </Tooltip>
    );
  }

  if (isActive) {
    return (
      <Tooltip title="DAG is active and unpaused in MWAA">
        <Tag icon={<CheckCircleFilled />} color="success" style={tagStyle}>
          Active
        </Tag>
      </Tooltip>
    );
  }

  return (
    <Tooltip title="DAG is inactive in MWAA">
      <Tag
        icon={<MinusCircleFilled />}
        color="default"
        style={{
          ...tagStyle,
          color: isDark ? '#8b949e' : undefined,
        }}
      >
        Inactive
      </Tag>
    </Tooltip>
  );
}
